import { errorMessage } from "@/lib/errorMessage";

/**
 * A server refusal's own sentence, shown verbatim: the API answers a validation failure with
 * `message: "Validation failed"` and the sentence in `error.details` (surfaced by `apiRequest` as
 * `errorDetails`), so that comes first; then the error message; then the fallback.
 */
export function splashServerMessage(error: unknown, fallback: string): string {
  const details = (error as { errorDetails?: unknown } | null)?.errorDetails;
  if (typeof details === "string" && details.trim()) return details.trim();
  return errorMessage(error, fallback);
}

/**
 * The server's file sentences (AppSplashService + the shared Lottie rules: size, type, MP4,
 * Lottie structure — pictures, text, not playable — and the upload ones). These are shown under
 * the File field; every other refusal (overlap, app, dates, name) under the form.
 */
const FILE_SENTENCE_STARTS = [
  "The video must",
  "The Lottie file",
  "This isn't an MP4",
  "This isn't a Lottie",
  "This animation",
  "Upload the file",
  "Upload an MP4",
  "The upload didn't finish",
] as const;

export function isSplashFileSentence(sentence: string): boolean {
  return FILE_SENTENCE_STARTS.some((start) => sentence.startsWith(start));
}
